import { LibCategory, TagCategory } from '@shared/constants'
import config from 'config'
import env from 'env'

import { deleteRequest, getRequest, postRequest } from './request'

const DOMAIN = env === 'local' ? config.domain : location.origin


export * from './file'
export * from './auth'
export * from './user'
export * from './folder'
export * from './template'
export * from './notification'


// ====== lib =======
export const getLibraryRecords = (from: number, size: number, cond: {
  category: LibCategory
  keyword?: string
  logicCategory?: TagCategory
}) => {
  const { keyword, category, logicCategory } = cond
  return getRequest(`${DOMAIN}/api/resource/libraries`, {
    keyword,
    from,
    size,
    category,
    logicCategory
  })
}

export const getMyLibraryRecords = (keyword?: string) => {
  return getRequest(`${DOMAIN}/api/my/libraries`, {
    keyword
  })
}

export const installLibrary = (libId: string) => {
  return postRequest(`${DOMAIN}/api/my/libraries`, {
    id: libId
  })
}

export const unInstallLibrary = (libId: string) => {
  return deleteRequest(`${DOMAIN}/api/my/libraries/${libId}`)
}

export const resetAllLibrary = () => {
  return deleteRequest(`${DOMAIN}/api/my/libraries`)
}

export const savePersonalLibrary = (data: {
  sourceId: string
  name: string
  description: string
}) => {
  return postRequest(`${DOMAIN}/api/my/personal/library`, data)
}


